namespace Gamification.Gamification {
    export interface RisorseChecklistRow {
        IdRisorsaChecklist?: number;
        UserId?: number;
        TenantId?: number;
        IdRisorsa?: number;
        IdChecklist?: number;
        IdRisorsaUserId?: number;
        IdRisorsaTenantId?: number;
        IdRisorsaIdTipologiaRisorsa?: number;
        IdRisorsaIdEstensione?: number;
        IdRisorsaIdTipologiaCaricamento?: number;
        IdRisorsaNome?: string;
        IdRisorsaDescrizione?: string;
        IdRisorsaNomeFileAssetBundle?: string;
        IdRisorsaNomeFileAssetPathFile?: string;
        IdRisorsaVersioneAssetBundle?: number;
        IdRisorsaUrlAssetBundle?: string;
        IdRisorsaNomeFileCoverAssetBundle?: string;
        IdRisorsaPathFileCoverAssetBundle?: string;
        IdRisorsaUrlCoverAssetBundle?: string;
        IdRisorsaEscludi?: number;
        IdChecklistUserId?: number;
        IdChecklistTenantId?: number;
        IdChecklistIdAssetEsperienza?: number;
        IdChecklistNome?: string;
        IdChecklistProgressivo?: number;
    }

    export namespace RisorseChecklistRow {
        export const idProperty = 'IdRisorsaChecklist';
        export const localTextPrefix = 'Gamification.RisorseChecklist';
        export const deletePermission = 'Gamification:Risorse';
        export const insertPermission = 'Gamification:Risorse';
        export const readPermission = 'Gamification:Risorse';
        export const updatePermission = 'Gamification:Risorse';

        export declare const enum Fields {
            IdRisorsaChecklist = "IdRisorsaChecklist",
            UserId = "UserId",
            TenantId = "TenantId",
            IdRisorsa = "IdRisorsa",
            IdChecklist = "IdChecklist",
            IdRisorsaUserId = "IdRisorsaUserId",
            IdRisorsaTenantId = "IdRisorsaTenantId",
            IdRisorsaIdTipologiaRisorsa = "IdRisorsaIdTipologiaRisorsa",
            IdRisorsaIdEstensione = "IdRisorsaIdEstensione",
            IdRisorsaIdTipologiaCaricamento = "IdRisorsaIdTipologiaCaricamento",
            IdRisorsaNome = "IdRisorsaNome",
            IdRisorsaDescrizione = "IdRisorsaDescrizione",
            IdRisorsaNomeFileAssetBundle = "IdRisorsaNomeFileAssetBundle",
            IdRisorsaNomeFileAssetPathFile = "IdRisorsaNomeFileAssetPathFile",
            IdRisorsaVersioneAssetBundle = "IdRisorsaVersioneAssetBundle",
            IdRisorsaUrlAssetBundle = "IdRisorsaUrlAssetBundle",
            IdRisorsaNomeFileCoverAssetBundle = "IdRisorsaNomeFileCoverAssetBundle",
            IdRisorsaPathFileCoverAssetBundle = "IdRisorsaPathFileCoverAssetBundle",
            IdRisorsaUrlCoverAssetBundle = "IdRisorsaUrlCoverAssetBundle",
            IdRisorsaEscludi = "IdRisorsaEscludi",
            IdChecklistUserId = "IdChecklistUserId",
            IdChecklistTenantId = "IdChecklistTenantId",
            IdChecklistIdAssetEsperienza = "IdChecklistIdAssetEsperienza",
            IdChecklistNome = "IdChecklistNome",
            IdChecklistProgressivo = "IdChecklistProgressivo"
        }
    }
}
